import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import Container from '@mui/material/Container';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import { createFileRoute, Link } from '@tanstack/react-router';
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useFirebase } from '@/firebase';

export const Route = createFileRoute('/restore-account')({ component: RestoreAccountPage });

function RestoreAccountPage() {
  const { t } = useTranslation();
  const { backend, user } = useFirebase();
  const [state, setState] = useState<'loading' | 'success' | 'error'>('loading');
  const started = useRef(false);

  useEffect(() => {
    if (started.current) return;
    started.current = true;
    const token = new URLSearchParams(window.location.search).get('token') || '';
    if (!token) {
      setState('error');
      return;
    }
    void backend.billing.restoreAccountDeletion(token)
      .then(async () => {
        await user?.getIdToken(true);
        setState('success');
      })
      .catch(() => setState('error'));
  }, [backend, user]);

  return (
    <Box sx={{ minHeight: '100vh', py: 10, bgcolor: 'background.default' }}>
      <Container maxWidth="sm">
        <Paper sx={{ p: 5, textAlign: 'center' }}>
          <Typography variant="h4" gutterBottom>{t('accountDeletion.restoreTitle')}</Typography>
          {state === 'loading' && <CircularProgress />}
          {state === 'success' && <Alert severity="success">{t('accountDeletion.restoreSuccess')}</Alert>}
          {state === 'error' && <Alert severity="error">{t('accountDeletion.restoreError')}</Alert>}
          {state !== 'loading' && (
            <Button component={Link} to="/login" variant="contained" sx={{ mt: 3 }}>
              {t('accountDeletion.goToLogin')}
            </Button>
          )}
        </Paper>
      </Container>
    </Box>
  );
}
